import { ColumnModel, FilterModel } from '../../filter';

export const WorkspaceFilterKey = 'WORKSPACE_FILTER';
export const WorkspaceOrderKey = 'WORKSPACE_ORDER';
export const WorkspaceFilterColumns = [
  'owner',
  'type',
  'assetsCount',
  'routinesCount',
  'peopleCount',
  'activitiesCount',
  'groupsCount',
  'createdAt',
  'lastScanned',
  'updatedAt',
  'lastActivity',
]
export class WorkspaceFilterModel implements FilterModel, ColumnModel {
  keyword?: string;
  columns?: string[];

  constructor(data?: any) {
    this.keyword = data?.keyword;
    this.columns = data?.columns || WorkspaceFilterColumns;
  }

  public getColumnsCount(): number {
    return this.columns && this.columns.length > 0 ? this.columns.length : 0;
  }  

  public getGraphQLFilter(): any {
    const filter = {} as any;

    if (this.keyword) {
      filter.keyword = this.keyword;
    }

    return filter;
  }
}
